import templateUrl from "emun.prospect/prospect-status.htm";
import basicController from "servicestack/basic.controller.properties";
import actionList from "webmodals/action-list";
import ServiceBus from "servicestack/service-bus";
import CustomerNotePrompt from "emun.customer/customer-note-prompt";
import ProspectConvertPrompt from "emun.prospect/prospect-convert-prompt";
import $session from "servicestack/session";

const actions = {
  New: { key: "New", icon: "exclamation text-danger", body: "" },
  Dead: { key: "Dead", icon: "times text-color-6", body: "" },
  Active: { key: "Active", icon: "arrow-right text-color-7", body: "" },
  Converted: { key: "Converted", icon: "check text-color-8", body: "" }
};
class ProspectStatusController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.actions = actions;
    let bus = ($ctrl.bus = new ServiceBus());
  }
  prompt() {
    const $ctrl = this;
    actionList({
      title: "Select a status...",
      actions,
      size: "sm"
    }).then(a => $ctrl.change(a.key));
  }
  change(status) {
    const $ctrl = this;
    if (status == "Converted") {
      ProspectConvertPrompt.open({ prospect: $ctrl.ngModel }).then(res => {
        $ctrl.ngChange && $ctrl.ngChange({ status });
        if (
          res.data.status == "Converted" &&
          res.data.customerId &&
          res.data.mode == "new"
        ) {
          $ctrl.$state.go("customer.edit", {
            customerId: res.data.customerId
          });
        }
      });
    } else {
      $ctrl.ngModel.status = status;
      $ctrl.bus.send("UpdateProspect.json", $ctrl.ngModel).then(res => {
        $ctrl.ngChange && $ctrl.ngChange({ status });
        if (status == "Dead") {
          var options = {
            title: "Reason for prospect status change",
            model: {
              customer: $ctrl.ngModel,
              prospectmode: true,
              note: {
                note: "",
                createdBy: $session.userName,
                createdOn: new Date(),
                retailerId: $ctrl.ngModel.id
              }
            }
          };
          CustomerNotePrompt.open(options).then(function(res) {});
        }
      });
    }
  }
  getIconClasses(status) {
    for (let i in actions)
      if (actions[i].key === status) return actions[i].icon;
    return "help text-info";
  }
}

let ProspectStatus = {
  controller: ProspectStatusController,
  bindings: {
    ngModel: "=?",
    ngChange: "&"
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default ProspectStatus;
